import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      condition: false
    };
  }
  handleClick() {
    this.setState({
      condition: !this.state.condition
    });
  }

  render() {
    return (
      <nav className={this.state.condition ? 'active' : ''}>
        <a className="menu" onClick={() => this.handleClick()}>
          <i className="material-icons">menu</i>
        </a>
        <h2>
          CPA-10: <span>trilha de estudos</span>
        </h2>
        <ul>
          <li>
            <NavLink to="/sistema-financeiro" activeClassName="active">
              <i className="material-icons">insert_drive_file</i>
              1. Sistema Financeiro Nacional e participantes do mercado
            </NavLink>
          </li>
          <li>
            <NavLink to="/analise-do-perfil-investidor" activeClassName="active">
              <i className="material-icons">insert_drive_file</i>
              2. Ética, regulamentação e análise do perfil do investidor
            </NavLink>
          </li>
          <li>
            <NavLink to="/conceitos-basicos-economia-financas" activeClassName="active">
              <i className="material-icons">insert_drive_file</i>
              3. Conceitos básicos de economia e finanças
            </NavLink>
          </li>
          <li>
            <NavLink to="/principios-de-investimento" activeClassName="active">
              <i className="material-icons">insert_drive_file</i>
              4. Princípios de investimento
            </NavLink>
          </li>
          <li>
            <NavLink to="/fundos-de-investimento" activeClassName="active">
              <i className="material-icons">insert_drive_file</i>
              5. Fundos de investimento
            </NavLink>
          </li>
          <li>
            <NavLink to="/renda-variavel-fixa" activeClassName="active">
              <i className="material-icons">insert_drive_file</i>
              6. Instrumentos de renda variável e renda fixa
            </NavLink>
          </li>
          <li>
            <NavLink to="/previdencia" activeClassName="active">
              <i className="material-icons">insert_drive_file</i>
              7. Previdência complementar aberta: PGBL e VGBL
            </NavLink>
          </li>
        </ul>
      </nav>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/Nav.js